import { httpRequest } from 'http'
import { clan_supply_quests_info_mock } from '../../containers/ClanLanding/mocks/clan_supply_quests_info_mock'
import isEmpty from 'lodash/isEmpty'

import { sendClanSupplyErrorNotification } from 'helpers/web_to_client'

export const CLAN_SUPPLY_QUESTS_REQUEST = 'clan_supply_quests/INFO_REQUEST'
export const CLAN_SUPPLY_QUESTS_SUCCESS = 'clan_supply_quests/INFO_SUCCESS'
export const CLAN_SUPPLY_QUESTS_ERROR = 'clan_supply_quests/INFO_ERROR'

export function clanSupplyQuestsRequestStart() {
    return {
        type: CLAN_SUPPLY_QUESTS_REQUEST,
    }
}

export function clanSupplyQuestsRequestSuccess(data) {
    return {
        type: CLAN_SUPPLY_QUESTS_SUCCESS,
        payload: data,
    }
}

export function clanSupplyQuestsRequestError(errorData) {
    return {
        type: CLAN_SUPPLY_QUESTS_ERROR,
        payload: errorData,
    }
}

export const REQUEST_INTERVAL = 3000

export function requestClanSupplyQuestsInfo() {
    return async (dispatch, getState) => {
        const state = getState()
        const requestNotPossibleByTimeout = state.clanSupplyQuests.lastRequestTimestamp &&
            (Date.now() - state.clanSupplyQuests.lastRequestTimestamp) < REQUEST_INTERVAL
        if (state.clanSupplyQuests.loading || requestNotPossibleByTimeout) {
            return
        }

        await makeQuestsInfoRequest(dispatch)
    }
}

export function requestToTakeRewards() {
    return async () => {
        try {
            const request = process.env.API_ENV === 'mock' ?
                {} :
                httpRequest(`${window.config.WGCG_API_URL}/clansupply/landing/clansupply/claim_rewards/`, 'POST')

            const data = await request

            if (!isEmpty(data)) {
                // noinspection ExceptionCaughtLocallyJS
                throw new Error()
            }
        } catch (errorData) {
            sendClanSupplyErrorNotification()
        }
    }
}

async function makeQuestsInfoRequest(dispatch) {
    dispatch(clanSupplyQuestsRequestStart())

    try {
        const request = process.env.API_ENV === 'mock' ?
            clan_supply_quests_info_mock() :
            httpRequest(`${window.config.WGCG_API_URL}/clansupply/landing/clansupply/quests/`)

        let data = await request

        if (data.enabled && data.quest_info.length === 0) {
            const postRequest = process.env.API_ENV === 'mock' ?
                clan_supply_quests_info_mock() :
                httpRequest(`${window.config.WGCG_API_URL}/clansupply/landing/clansupply/quests/`, 'POST')

            data = await postRequest
        }

        dispatch(clanSupplyQuestsRequestSuccess(data))
    } catch (errorData) {
        if (errorData.statusCode === 503) {
            dispatch(clanSupplyQuestsRequestSuccess({ enabled: false }))

            return
        }
        dispatch(clanSupplyQuestsRequestError(errorData))
    }
}



// WEBPACK FOOTER //
// ./state/actions/clan_supply_quests.js